/**
 * Model to hold Stripe account details
 */
import { StripeAccount } from '@reg/shared/model/stripe-account.model';

export class StripeAccountDetails {
    public id: string;
    public isChargesEnabled: boolean;
    public isPayoutsEnabled: boolean;
    public isRequirementCurrentlyDue: boolean;
    public isRequirementPastDue: boolean;
    public disabledReason: string;
    public type: string;

    public isExpress(): boolean {
        return this.type === StripeAccount.TYPE_EXPRESS;
    }

    public deserialize(json: any): StripeAccountDetails {
        this.id = json.id;
        this.isChargesEnabled = json.charges_enabled;
        this.isPayoutsEnabled = json.payouts_enabled;
        this.type = json.type;

        if (json.disabledReason) {
            // https://stripe.com/docs/api/accounts/object#account_object-requirements-disabled_reason
            // Convert a reason like 'requirements.pending_verification' to 'Requirements => Pending Verification'
            this.disabledReason = json.disabledReason.replace('.', ' => ');
            this.disabledReason = this.disabledReason.replace(/_/g, ' ');
        }

        if (json.requirements) {
            this.isRequirementCurrentlyDue = (json.requirements.currently_due || []).length > 0;
            this.isRequirementPastDue = (json.requirements.past_due || []).length > 0;
        }

        return this;
    }
}
